import { EventEmitter, Injectable } from '@angular/core';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class ExcelService {

  data: any[] = [];
  displayedColumns: string[] = [];
  fileDataEmitter:EventEmitter<any> = new EventEmitter<any>;
  fileNameEmit:EventEmitter<any> = new EventEmitter<any>();
  fileName:any;

  constructor() { }

  fileUpdload(file: File,screen:string) {
    if (file) {
      const reader: FileReader = new FileReader();
      reader.onload = (e: any) => {
        try{
        const bstr: string = e.target.result;
        this.fileName = file.name;
        this.fileNameEmit.emit(this.fileName);
        const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];
        

        // Store the data
        let data = XLSX.utils.sheet_to_json(ws, { defval: '' });// for null values
        this.displayedColumns = Object.keys(data[0]|| {}); // for null values
        this.data=[]
        if(screen === 'fuel-escalator' && this.displayedColumns.includes('Including Taxes') && this.displayedColumns.includes('Index Value')){
          this.data = data;
        }
        else if(screen === 'bidpack' && this.displayedColumns.includes('Supplier GSDB') && this.displayedColumns.includes('Zipcode')&& this.displayedColumns.includes('Zip Area')){
          this.data = data;
        }
      }
        catch(e){
          console.error('File is corrupted:', e);
        }
      };
      reader.readAsBinaryString(file);
    }
  }

  saveAsExcel() {
    // Create a new workbook
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.data);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    // Generate buffer
    const wbout: ArrayBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

    // Trigger download
    saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'BidPack_Origin_File.xlsx');
  }

}
